import axios from 'axios';

const defaultURL = 'https://treant.ru';
const storageKey = 'auth_server_url';

const GetAuthServerURL = () => { 
  var url = localStorage.getItem(storageKey);
  if (!url) {
    url = defaultURL
    localStorage.setItem(storageKey, url);
  }
  return url;
}

const authService = axios.create({
  baseURL: GetAuthServerURL() + '/api', // Через Nginx
});

// Interceptor для добавления токена в заголовки
authService.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor для отлова 401 ошибки
authService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem('access_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default authService;